import InvitationsManagement from "./InvitationsManagement";

export default InvitationsManagement;